import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { tourScheduleProjection } from "../sanity/tourSchedule.projection"

export const queryTourSchedules = {
  async tourSchedules(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, offset, limit, sort, sortWithinLimits } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.TOURS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    const tourSchedules = await client.fetch(
      groq`{
        "total": count(*[_type=="tourSchedule"]),
        "items": *[_type=="tourSchedule" ${draftsFilter}]${pipesAndLimits}{
          ${tourScheduleProjection()}
        }
      }`,
    )

    if (tourSchedules.items && tourSchedules.items.length !== 0) {
      const { items, total } = tourSchedules

      return {
        total,
        items: items.map((tourSchedule) => {
          return {
            ...tourSchedule,
            tours: [
              tourSchedule.tour01,
              tourSchedule.tour02,
              tourSchedule.tour03,
              tourSchedule.tour04,
              tourSchedule.tour05,
              tourSchedule.tour06,
              tourSchedule.tour07,
              tourSchedule.tour08,
            ],
          }
        }),
      }
    }

    return null
  },
}
